import { Link, useLocation, Outlet } from 'react-router-dom'
import { Home, List, ShoppingCart, CalendarDays } from 'lucide-react'
import { useCart } from '../contexts/CartContext'
import { useLanguage } from '../contexts/LanguageContext'

export default function CustomerLayout() {
  const location = useLocation()
  const { getTotalItems } = useCart()
  const { t, isRTL } = useLanguage()
  const pathname = location.pathname
  const isItemDetailPage = /^\/item\/[^/]+$/.test(pathname)
  const isCartPage = pathname === '/cart'
  const isReservationFormPage = pathname === '/reservation'
  const cartHasItems = getTotalItems() > 0
  const hideBottomNav = isItemDetailPage || isReservationFormPage || (isCartPage && cartHasItems)

  return (
    <div className={`min-h-screen bg-[#fafafa] flex flex-col ${hideBottomNav ? 'pb-0' : 'pb-24'}`} dir={isRTL ? 'rtl' : 'ltr'}>
      {/* Small white top area - sticky so it stays at top when scrolling */}
      <div className="sticky top-0 z-20 min-h-8 shrink-0 bg-[#fafafa] pt-[env(safe-area-inset-top,0px)]" aria-hidden />
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Bottom navigation - hidden on item detail page (page has its own add-to-order bar) */}
      {!hideBottomNav && (
      <nav className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-lg rounded-2xl bg-orange-500 shadow-lg safe-area-pb">
        <div className="flex items-center justify-around h-14 px-2">
          <Link
            to="/"
            className={`flex flex-col items-center justify-center flex-1 py-2 transition-colors ${
              pathname === '/' ? 'text-white' : 'text-white/80 hover:text-white'
            }`}
          >
            <Home className={`w-6 h-6 ${pathname === '/' ? 'fill-white' : ''}`} />
            <span className="text-xs mt-0.5">{t('home')}</span>
          </Link>
          <Link
            to="/my-orders"
            className={`flex flex-col items-center justify-center flex-1 py-2 transition-colors ${
              pathname === '/my-orders' ? 'text-white' : 'text-white/80 hover:text-white'
            }`}
          >
            <List className={`w-6 h-6 ${pathname === '/my-orders' ? 'fill-white' : ''}`} />
            <span className="text-xs mt-0.5">{t('orders')}</span>
          </Link>
          <Link
            to="/cart"
            className={`relative flex flex-col items-center justify-center flex-1 py-2 transition-colors ${
              pathname === '/cart' ? 'text-white' : 'text-white/80 hover:text-white'
            }`}
          >
            <ShoppingCart className={`w-6 h-6 ${pathname === '/cart' ? 'fill-white' : ''}`} />
            {getTotalItems() > 0 && (
              <span className="absolute top-1.5 right-1/4 bg-white text-orange-500 text-xs font-semibold rounded-full min-w-[18px] h-[18px] flex items-center justify-center">
                {getTotalItems()}
              </span>
            )}
            <span className="text-xs mt-0.5">{t('cart')}</span>
          </Link>
          <Link
            to="/reservation"
            className={`flex flex-col items-center justify-center flex-1 py-2 transition-colors ${
              pathname === '/reservation' || pathname === '/reservation-success' ? 'text-white' : 'text-white/80 hover:text-white'
            }`}
          >
            <CalendarDays className={`w-6 h-6 ${pathname === '/reservation' || pathname === '/reservation-success' ? 'fill-white' : ''}`} />
            <span className="text-xs mt-0.5">{t('reservation')}</span>
          </Link>
        </div>
      </nav>
      )}
    </div>
  )
}
